var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.333 14.1v2.5a1.666 1.666 0 0 1-1.816 1.667 16.5 16.5 0 0 1-7.192-2.559 16.25 16.25 0 0 1-5-5 16.5 16.5 0 0 1-2.558-7.225 1.667 1.667 0 0 1 1.658-1.816h2.5A1.67 1.67 0 0 1 7.592 3.1c.105.8.3 1.586.583 2.342A1.67 1.67 0 0 1 7.8 7.2L6.742 8.258a13.33 13.33 0 0 0 5 5L12.8 12.2a1.67 1.67 0 0 1 1.758-.375 10.7 10.7 0 0 0 2.342.583 1.667 1.667 0 0 1 1.433 1.692"
  })));
};
export default SvgPhone;